import { PeanutOutlineIcon } from './PeanutOutlineIcon';

/**
 * author: Michael Richins
 * id C3883026-99A7-48ED-898E-37AC117A6C4F
 * name peanut-outline
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/peanut-outline.svg
 * tags
 * - Food / Drink 
 * - Agriculture 
 */
export const AllergenOutlineIcon = PeanutOutlineIcon;
export default AllergenOutlineIcon